import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsAmexNewContentMocks: MicroMoments = {
  id: '',
  title:
    'Jordan, thank you for being a Loyal Delta SkyMiles® American Express Card Holder!',
  description: 'Explore your access to exclusive discounted award flights.',
  action: {
    label: 'Learn More',
    url: 'https://www.delta.com/us/en/skymiles/airline-credit-cards/plan-it-by-american-express'
  },
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/amex-card-holder.svg',
    alt: 'Amex Logo'
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
